/**
 * Module dependencies,
 */

import { Breakpoint, breakpoints } from '../breakpoints';
import { type Interpolation, type RuleSet, css } from 'styled-components';

/**
 * `Query` type.
 */

type Query = (styles: TemplateStringsArray, ...interpolations: Array<Interpolation<object>>) => RuleSet<object>;

/**
 * `Media` type.
 */

type Media = Record<'max' | 'min', Record<Breakpoint, Query>>;

/**
 * Render query.
 */

function renderQuery(orientation: string, value: number): Query {
  return (styles, ...interpolations) => css`
    /* stylelint-disable-next-line */
    @media (${orientation}: ${value}px) {
      ${css(styles, ...interpolations)}
    }
  `;
}

/**
 * `initialQueries` constant.
 */

const initialQueries = {
  max: {},
  min: {}
} as const;

/**
 * Export `media` util.
 */

export const media = (Object.entries(breakpoints) as []).reduce(
  (queries: typeof initialQueries, [key, value]: [Breakpoint, number]) => ({
    max: {
      ...queries.max,
      [key]: renderQuery('max-width', value - 1)
    },
    min: {
      ...queries.min,
      [key]: renderQuery('min-width', value)
    }
  }),
  initialQueries
) as Media;
